export default class CommandeComposantController {
    static $inject = ['$scope', '$stateParams', 'CommandesCommunicationService', 'CommandesService', 'notification', '$uibModal'];

    constructor($scope, $stateParams, CommandesCommunicationService, CommandesService, notification, $uibModal) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.CommandesCommunicationService = CommandesCommunicationService;
        this.CommandesService = CommandesService;
        this.notification = notification;
        this.$uibModal = $uibModal;
    }

    async $onInit() {
        this.unregister = this.$scope.$watch(
            () => this.isOpen,
            () => {
                if (this.isOpen && !this.commandes) {
                    this.loadCommandes();
                }
            },
            true
        );
    }

    $onDestroy() {
        this.unregister();
    }

    async loadCommandes() {
        if (this.id) {
            this.startLoading();
            try {
                this.commandes = await this.CommandesService.getCommandeComposant(this.id, this.domaine);
            } catch (err) {
                if (err.data) {
                    this.notification.error(err.data);
                } else {
                    throw err;
                }
            }
            this.stopLoading();
        }
    }

    async exporter() {
        try {
            this.startLoading();
            this.isLoadExport = true;
            const fileName = 'Liste_commandes';
            let resultat = undefined;
            try {
                resultat = await this.CommandesService.exportCommandeComposants(this.id, this.domaine);
            } catch (ex) {
                //si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
                const msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
                this.notification.error('COMMANDES.' + msgException);
                return false;
            }
            if (resultat) {
                const data = resultat.data;
                const status = resultat.status;
                let headers = resultat.headers;
                headers = headers();

                const contentType = headers['content-type'];

                const linkElement = document.createElement('a');
                try {
                    const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
                    const url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', fileName + '.xlsx');

                    const clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                } finally {
                }
                return true;
            }
        } catch (ex) {
            this.notification.error(ex.data);
            return false;
        } finally {
            this.stopLoading();
            this.isLoadExport = false;
        }
    }

    openCommande(commande) {
        this.$uibModal
            .open({
                template: '<commande-form modal-instance="$ctrl.uibModalInstance" id-commande="$ctrl.idCommande"></commande-form>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        const $ctrl = this;
                        $ctrl.uibModalInstance = $uibModalInstance;
                        $ctrl.idCommande = commande;
                    }
                ],
                controllerAs: '$ctrl',
                size: 'xxl'
            })
            .result.then(
                async function (result) {
                    // console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
                    // console.info(result);
                    if (result) {
                    }
                },
                function (reason) {}
            );
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
